import React, { useEffect, useState } from "react";
import axios from "axios";
import { getBaseUrl } from "../../utils";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
const LoginTwo = ({ nextStep, handleFormData, values }) => {
    const baseUrl = getBaseUrl();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    useEffect(() => {
        const token = localStorage.getItem("userToken");
        if (token) {
            navigate("/dashboard"); // Redirect to dashboard if token exists
        }
    }, [navigate]);

    const sendOtp = async (e) => {
        e.preventDefault();

        if (!values.phone || values.phone.length !== 10) {
            alert("Please enter a valid 10-digit phone number.");
            return;
        }

        setLoading(true);

        try {
            const response = await axios.post(baseUrl + "user_api/userAuthentication", {
                number: values.phone,
                otp: "",
                deviceType: "WEB", // Adjust based on your device type (e.g., Android, IOS)
                deviceID: "unique_device_id", // Replace with actual device ID if available
                deviceToken: "token_here", // Replace with actual device token if available
            });

            setLoading(false);

            if (response.data.status) {
                alert("OTP sent successfully to your phone.");
                nextStep(); // Proceed to OTP verification step
            } else {
                alert(response.data.message);
            }
        } catch (error) {
            setLoading(false);
            alert("An error occurred. Please try again later.");
        }
    };

    return (
        <div>
            <section>
                <Link to='/'>
                    <button className="bg-black px-8 py-2.5 shadow-lg fixed top-4 right-4 rounded-lg text-white">
                        <h1>Go To Home</h1>
                    </button>
                </Link>


                <div className="container-xxl pl-0 pt-[20px]">
                    <div className="row">
                        <div className="col-12 flex items-center justify-center">
                            <div className="md:w-[900px] w-full flex h-[541px]">
                                <div className="w-full md:block hidden">
                                    <img
                                        src="/assates/Login.png"
                                        className="h-full w-full"
                                    />
                                </div>
                                <div className="w-full md:shadow-xl md:p-4  rounded-br-xl rounded-tr-xl">
                                    <div className="pt-[55px]">
                                        <div className="flex items-center justify-center">
                                             <img src="/assates/Logo__newimage-removebg-preview.png" className="w-[200px] rounded-lg" />
                                        </div>
                                        <h1 className="text-center Header__text font-[700]">
                                            Welcome Back!
                                        </h1>
                                        <p className="text-center Paragraph__etxt font-[500] pb-12">
                                            Please enter your Phone Number to
                                            continue.
                                        </p>

                                        <form onSubmit={sendOtp}>
                                            <div className="flex justify-between gap-[20px]">
                                                <div className="bg-[#FFFFFF] w-[80px] rounded-[15px] flex items-center justify-center">
                                                    +91
                                                </div>
                                                <div className="flex bg-[#FFFFFF] pl-3 w-full rounded-[10px] items-center">
                                                    <div>
                                                        <img
                                                            src="/assates/call.svg"
                                                            alt="images"
                                                        />
                                                    </div>
                                                    <div className="w-full pl-2 pr-2">
                                                        <input
                                                            type="number"
                                                            name="phone"
                                                            required
                                                            placeholder="Enter your phone number"
                                                            className="w-full p-3"
                                                            style={{
                                                                outline: "none",
                                                            }}
                                                            value={values.phone}
                                                            onChange={handleFormData("phone")}
                                                            maxLength={10} // This will not work for "number" type, so we need extra validation
                                                            onInput={(e) => {
                                                                if (e.target.value.length > 10) {
                                                                    e.target.value = e.target.value.slice(0, 10); // Trim the input to 10 digits
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <button
                                                type="submit"
                                                className={`mt-8 w-full flex items-center bg-[#28282B] text-white gap-2 Paragraph__etxt font-[500] h-[50px] justify-center choose_qulifation_section rounded-lg ${loading ? "cursor-not-allowed" : ""
                                                    }`}
                                                disabled={loading}
                                            >
                                                {loading ? "Sending OTP..." : "Send OTP"}
                                            </button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default LoginTwo;
